import { Dispatch, ReactNode, SetStateAction, useState } from 'react'
import { usePhoneManagementCtx } from '../PhoneManagement.context'
import { useSettingsHeader } from '@pages/Settings/SettingsHeader.context'

interface IAddPhoneNumberHooks {
  cancelToList: () => void
  method: 'port' | 'purchase' | null
  saveNumber: () => void
  setHeaderButtons: Dispatch<SetStateAction<ReactNode | null>>
  setHeaderTitle: Dispatch<SetStateAction<ReactNode | null>>
  setMethod: Dispatch<SetStateAction<'port' | 'purchase' | null>>
  setShowPortModal: Dispatch<SetStateAction<boolean>>
  showPortModal: boolean
}

const useAddPhoneNumber = (): IAddPhoneNumberHooks => {
  const hooks = usePhoneManagementCtx()
  const { setHeaderButtons, setHeaderTitle } = useSettingsHeader()
  const [showPortModal, setShowPortModal] = useState(false)
  const [method, setMethod] = useState<'port' | 'purchase' | null>(null)

  const saveNumber = (): void => {
    if (method === 'port') {
      setShowPortModal(true)
    }
  }

  return {
    cancelToList: hooks.cancelToList,
    method,
    saveNumber,
    setHeaderButtons,
    setHeaderTitle,
    setMethod,
    setShowPortModal,
    showPortModal,
  }
}

export default useAddPhoneNumber
